/** The task of a group work: what the room works on. */
export type SimpleGroupingTask = {
	name?: string
	description?: string
}

export type State = SimpleGroupingTask & {
	started: boolean
}

const initialState: State = {
	started: false,
}

type Action = {
	type: 'SSE_SIMPLE_GROUPING_STATE_CHANGED'
	payload: {
		enabled: boolean
		name?: string | null
		description?: string | null
	}
}

export function reducer(state: State = initialState, action: Action): State {
	switch (action.type) {
		case 'SSE_SIMPLE_GROUPING_STATE_CHANGED':
			return {
				...state,
				started: action.payload.enabled,
				name: action.payload.name || undefined,
				description: action.payload.description || undefined,
			}
		default:
			return state
	}
}
